// extracted by mini-css-extract-plugin
export default {"copyContainer":"CopyToClipboard_copyContainer__-91dW","slim":"CopyToClipboard_slim__RcXUq","copyIconSlim":"CopyToClipboard_copyIconSlim__VOlfh"};